export const LIGHT = {
  bg: '#F1F8E9',
  surface: '#FFFFFF',
  surface2: '#F9FBE7',
  primary: '#1B5E20',
  primary2: '#2E7D32',
  primaryLight: '#E8F5E9',
  border: '#E0E0E0',
  borderLight: '#A5D6A7',
  text: '#212121',
  textSec: '#757575',
  textHint: '#9E9E9E',
  gold: '#C8A400',
  amber: '#E65100',
  amberLight: '#FFF3E0',
  red: '#C62828',
  redLight: '#FFEBEE',
  blue: '#1565C0',
  blueLight: '#E3F2FD',
  status: '#1B5E20',
  navBg: '#FFFFFF',
  headerBg: '#1B5E20',
  headerText: '#FFFFFF',
  pending: '#FFF8E1',
  pendingBorder: '#FFE082',
  pendingText: '#F57C00',
  isDark: false,
};

export const DARK = {
  bg: '#040507',
  surface: '#0a1208',
  surface2: '#0d1a0d',
  primary: '#81C784',
  primary2: '#4CAF50',
  primaryLight: '#0a1f0a',
  border: '#1a2e1a',
  borderLight: '#2E7D32',
  text: '#E0E0E0',
  textSec: '#9E9E9E',
  textHint: '#555555',
  gold: '#C8A400',
  amber: '#FF8A65',
  amberLight: '#1e1200',
  red: '#EF9A9A',
  redLight: '#1e0000',
  blue: '#90CAF9',
  blueLight: '#0d1a2e',
  status: '#040507',
  navBg: '#040507',
  headerBg: '#040f08',
  headerText: '#81C784',
  pending: '#1e1200',
  pendingBorder: '#4a3000',
  pendingText: '#FFB74D',
  isDark: true,
};
